import { render } from "./NewFeedbackDialog.vue?vue&type=template&id=95d41016"
import script from "./NewFeedbackDialog.vue?vue&type=script&lang=js"
export * from "./NewFeedbackDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__